import React from 'react';

import { CartView, CartMetadataItem, SummaryDisplayItem } from '../../types/cartTypes';
import { getProductName } from '../../utils/cartFormatting';
import { groupLineItemsByAssociation } from '../../utils/cartGrouping';
import OrderSummary from '../basket/orderSummary/basketOrderSummary';

interface CartSummaryProps {
  cart: CartView;
  currency: string;
  productMetadata: Record<string, CartMetadataItem>;
  onCheckout: () => void;
  onShare: () => void;
  isShareModalOpen: boolean;
  locale: string;
}

const CartSummary: React.FC<CartSummaryProps> = ({
  cart,
  currency,
  productMetadata,
  onCheckout,
  onShare,
  isShareModalOpen,
  locale,
}) => {
  const subtotal =
    cart.subtotal !== undefined && cart.subtotal !== null
      ? cart.subtotal
      : (cart.lineItems?.reduce((acc, li) => {
        const lineTotal =
          (li.totalPrice && ((li.totalPrice as { centAmount?: number }).centAmount ?? (li.totalPrice as { value?: { centAmount?: number } }).value?.centAmount ?? 0)) ||
          ((li.price && typeof li.price === 'object' && li.price.value?.centAmount ? li.price.value.centAmount : 0) * (li.quantity ?? 1));
        return acc + (typeof lineTotal === 'number' ? lineTotal : 0);
      }, 0) ?? 0);
      
  const subtotalMoney = { centAmount: subtotal, currencyCode: currency };

  const transformedLineItems: SummaryDisplayItem[] = (cart.groupedItems
    ? cart.groupedItems.map((group) => ({
      productName: group.mainItem ? getProductName(group.mainItem, locale) : 'Unknown Product',
      quantity: group.mainItem?.quantity ?? 0,
      price: {
        value: {
          centAmount: group.passesSubtotal ?? group.passesTotal ?? 0,
          currencyCode: group.currency ?? currency,
        },
      },
      totalPrice: {
        centAmount: group.groupSubtotal ?? group.passesSubtotal ?? group.passesTotal ?? group.totalPrice ?? 0,
        currencyCode: group.currency ?? currency,
      },
      addons: (group.addOns ?? []).map((addon) => ({
        name: addon.name,
        price: {
          centAmount: typeof addon.price === 'number' ? addon.price : 0,
          currencyCode: currency,
        },
      })),
      custom: group.mainItem?.custom,
    }))
    : groupLineItemsByAssociation(cart.lineItems, productMetadata as unknown as Record<string, { price?: number; name?: Record<string, string> }>, currency)
  ) as SummaryDisplayItem[];

  return (
    <div className={`col-start-1 md:col-start-2 flex flex-col w-full gap-0 p-0 bg-white border-none shadow-none opacity-100 relative z-10 ${isShareModalOpen ? 'hidden md:block' : ''}`}>
      <OrderSummary
        lineItems={transformedLineItems}
        effectiveSubtotal={subtotalMoney}
        onCheckout={onCheckout}
        onShare={onShare}
      />
    </div>
  );
};

export default CartSummary;
